module.exports = __webpack_public_path__ + "static/TANMEMORIES-Italic-94d3fc1a761a5f27246412bb48dde099.woff";